var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import { isNil } from 'lodash-es';
import { hideMenuProvider } from '../../utilities/picker.tools';
import styles from '../sds-date-picker.lit.scss';
import '../shared/calendar/sds-calendar.lit';
import { pairLessOrEqual, tripletLessOrEqual } from '../shared/comparators';
import { displayDate } from '../shared/display';
import { dateHoverStateMapper, dateRangeMapper, monthRangeMapper, yearRangeMapper, } from '../shared/mapper-utils';
import '../shared/month-view/month-view.lit';
import { getMonth, getYear } from '../shared/utils';
import { currentDateKey, dateToKey, keyToDate } from './date-picker-calculations';
import { translate } from '../../utilities/translate';
import { sdsCustomElement } from '../../utilities/custom-components';
/**
 * `sds-date-range` is a web component that enables users to select a range of dates.
 *
 * ### Features:
 * - **Start and End date inputs**: Allows users to select both the start and end dates.
 * - **Placeholder support** for guiding users when no date is selected.
 * - Emits events on value changes for integration with other components or business logic.
 */
let SdsDateRange = (() => {
    var _SdsDateRange_placeholder_accessor_storage, _SdsDateRange_startDate_accessor_storage, _SdsDateRange_endDate_accessor_storage, _SdsDateRange_hint_accessor_storage, _SdsDateRange_disabled_accessor_storage, _SdsDateRange_invalid_accessor_storage, _SdsDateRange_errorMessage_accessor_storage, _SdsDateRange_currentDay_accessor_storage, _SdsDateRange__contextMenu_accessor_storage, _SdsDateRange__inputDate_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-date-range')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _placeholder_decorators;
    let _placeholder_initializers = [];
    let _placeholder_extraInitializers = [];
    let _startDate_decorators;
    let _startDate_initializers = [];
    let _startDate_extraInitializers = [];
    let _endDate_decorators;
    let _endDate_initializers = [];
    let _endDate_extraInitializers = [];
    let _hint_decorators;
    let _hint_initializers = [];
    let _hint_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _invalid_decorators;
    let _invalid_initializers = [];
    let _invalid_extraInitializers = [];
    let _errorMessage_decorators;
    let _errorMessage_initializers = [];
    let _errorMessage_extraInitializers = [];
    let _currentDay_decorators;
    let _currentDay_initializers = [];
    let _currentDay_extraInitializers = [];
    let __contextMenu_decorators;
    let __contextMenu_initializers = [];
    let __contextMenu_extraInitializers = [];
    let __inputDate_decorators;
    let __inputDate_initializers = [];
    let __inputDate_extraInitializers = [];
    var SdsDateRange = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsDateRange_placeholder_accessor_storage.set(this, __runInitializers(this, _placeholder_initializers, 'sds.date_picker_range.placeholder'));
            _SdsDateRange_startDate_accessor_storage.set(this, (__runInitializers(this, _placeholder_extraInitializers), __runInitializers(this, _startDate_initializers, void 0)));
            _SdsDateRange_endDate_accessor_storage.set(this, (__runInitializers(this, _startDate_extraInitializers), __runInitializers(this, _endDate_initializers, void 0)));
            _SdsDateRange_hint_accessor_storage.set(this, (__runInitializers(this, _endDate_extraInitializers), __runInitializers(this, _hint_initializers, '')));
            _SdsDateRange_disabled_accessor_storage.set(this, (__runInitializers(this, _hint_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            _SdsDateRange_invalid_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _invalid_initializers, false)));
            _SdsDateRange_errorMessage_accessor_storage.set(this, (__runInitializers(this, _invalid_extraInitializers), __runInitializers(this, _errorMessage_initializers, '')));
            _SdsDateRange_currentDay_accessor_storage.set(this, (__runInitializers(this, _errorMessage_extraInitializers), __runInitializers(this, _currentDay_initializers, currentDateKey())));
            _SdsDateRange__contextMenu_accessor_storage.set(this, (__runInitializers(this, _currentDay_extraInitializers), __runInitializers(this, __contextMenu_initializers, void 0)));
            _SdsDateRange__inputDate_accessor_storage.set(this, (__runInitializers(this, __contextMenu_extraInitializers), __runInitializers(this, __inputDate_initializers, void 0)));
            this._sdsCalendar = __runInitializers(this, __inputDate_extraInitializers);
            this.hideMenu = hideMenuProvider(this);
            this.mouseOutHandler = () => {
                var _a;
                if (this.endDate === undefined) {
                    (_a = this._sdsCalendar) === null || _a === void 0 ? void 0 : _a.setDateStateMapper(dateRangeMapper(this.startDate, undefined));
                }
            };
            this.showContextMenu = () => {
                var _a, _b;
                if (!((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened)) {
                    this._inputDate.focused = true;
                    this.resetPage();
                    (_b = this._contextMenu) === null || _b === void 0 ? void 0 : _b.show(this._inputDate);
                    this.setMappers();
                }
            };
            this.handleCleared = () => {
                var _a;
                this._inputDate.focused = Boolean((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened);
                this.updateValue();
                this.updatePageIndex();
            };
            this.handleDatePicked = (event) => {
                this.updateValue(event.detail.date);
            };
            this.handleMonthSelect = (event) => {
                const [year, _] = event.detail.month;
                if (isNil(this.startDate) || !(isNil(this.startDate) || isNil(this.endDate))) {
                    this._preselectedStartYear = year;
                    this._preselectedEndYear = undefined;
                    this._preselectedStartMonth = event.detail.month;
                    this._preselectedEndMonth = undefined;
                }
                else {
                    this._preselectedEndYear = year;
                    this._preselectedEndMonth = event.detail.month;
                }
                this.setMappers();
            };
            this.handleYearSelect = (event) => {
                if (isNil(this.startDate) || !(isNil(this.startDate) || isNil(this.endDate))) {
                    this._preselectedStartYear = event.detail.year;
                    this._preselectedEndYear = undefined;
                }
                else {
                    this._preselectedEndYear = event.detail.year;
                }
                this.setMappers();
            };
            this.handleHover = (event) => {
                var _a;
                if (this.startDate !== undefined &&
                    this.endDate === undefined &&
                    event.detail.type === 'date') {
                    (_a = this._sdsCalendar) === null || _a === void 0 ? void 0 : _a.setDateStateMapper(dateHoverStateMapper(this.startDate, event.detail.hoveredItem));
                }
                else if (event.detail.hoveredItem === undefined) {
                    this.setMappers();
                }
            };
        }
        /**
         * Sets the placeholder text, providing a hint when no date is selected.
         * This helps guide users to understand the expected input format or purpose of the date range selection.
         *
         * @attr {string} placeholder - Placeholder text for the date range input.
         */
        get placeholder() { return __classPrivateFieldGet(this, _SdsDateRange_placeholder_accessor_storage, "f"); }
        set placeholder(value) { __classPrivateFieldSet(this, _SdsDateRange_placeholder_accessor_storage, value, "f"); }
        /** {year}/{month}/{day} format */
        get startDate() { return __classPrivateFieldGet(this, _SdsDateRange_startDate_accessor_storage, "f"); }
        set startDate(value) { __classPrivateFieldSet(this, _SdsDateRange_startDate_accessor_storage, value, "f"); }
        /** {year}/{month}/{day} format */
        get endDate() { return __classPrivateFieldGet(this, _SdsDateRange_endDate_accessor_storage, "f"); }
        set endDate(value) { __classPrivateFieldSet(this, _SdsDateRange_endDate_accessor_storage, value, "f"); }
        /**
         * Hint for this date range.
         * @attr
         */
        get hint() { return __classPrivateFieldGet(this, _SdsDateRange_hint_accessor_storage, "f"); }
        set hint(value) { __classPrivateFieldSet(this, _SdsDateRange_hint_accessor_storage, value, "f"); }
        /**
         * True if this date range is disabled.
         * @attr
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsDateRange_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsDateRange_disabled_accessor_storage, value, "f"); }
        /**
         * True if this date range is invalid.
         * @attr
         */
        get invalid() { return __classPrivateFieldGet(this, _SdsDateRange_invalid_accessor_storage, "f"); }
        set invalid(value) { __classPrivateFieldSet(this, _SdsDateRange_invalid_accessor_storage, value, "f"); }
        /**
         * The error message of this date range, in case there is a validation error.
         * @attr
         */
        get errorMessage() { return __classPrivateFieldGet(this, _SdsDateRange_errorMessage_accessor_storage, "f"); }
        set errorMessage(value) { __classPrivateFieldSet(this, _SdsDateRange_errorMessage_accessor_storage, value, "f"); }
        /**
         * Represents the currently selected or focused day within the date range picker.
         * It is initialized using the `currentDateKey()` function, which typically returns
         * the current date in a specific format.
         *
         * Defaults to the value returned by `currentDateKey()`.
         *
         * This attribute helps ensure the date picker is initialized with the appropriate day context.
         * It tracks or highlights the current day within the component and can be overridden
         * programmatically if needed to focus a different day.
         *
         * @attr {string} currentDay - The key representing the currently selected or focused day.
         */
        get currentDay() { return __classPrivateFieldGet(this, _SdsDateRange_currentDay_accessor_storage, "f"); }
        set currentDay(value) { __classPrivateFieldSet(this, _SdsDateRange_currentDay_accessor_storage, value, "f"); }
        get _contextMenu() { return __classPrivateFieldGet(this, _SdsDateRange__contextMenu_accessor_storage, "f"); }
        set _contextMenu(value) { __classPrivateFieldSet(this, _SdsDateRange__contextMenu_accessor_storage, value, "f"); }
        get _inputDate() { return __classPrivateFieldGet(this, _SdsDateRange__inputDate_accessor_storage, "f"); }
        set _inputDate(value) { __classPrivateFieldSet(this, _SdsDateRange__inputDate_accessor_storage, value, "f"); }
        render() {
            return html `
            <sds-input-date
                id="input-date"
                placeholder="${translate(this.placeholder)}"
                readonly
                ?disabled="${this.disabled}"
                hint="${this.hint}"
                error-message="${this.errorMessage}"
                ?invalid="${this.invalid}"
                @click="${this.showContextMenu}"
                @sds.input-date.cleared="${this.handleCleared}"
            ></sds-input-date>
            <sds-context-menu id="context-menu">
                <sds-calendar
                    currentDay="${this.currentDay}"
                    tabindex="0"
                    @mouseout="${this.mouseOutHandler}"
                    @sds.calendar.select="${this.handleDatePicked}"
                    @sds.calendar.hover="${this.handleHover}"
                    @sds.calendar.month.select="${this.handleMonthSelect}"
                    @sds.calendar.year.select="${this.handleYearSelect}"
                >
                </sds-calendar>
            </sds-context-menu>
        `;
        }
        connectedCallback() {
            super.connectedCallback();
            document.addEventListener('mouseup', this.hideMenu);
        }
        disconnectedCallback() {
            document.removeEventListener('mouseup', this.hideMenu);
            this.hideContextMenu();
            super.disconnectedCallback();
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        willUpdate(_changedProperties) {
            if (_changedProperties.has('startDate') || _changedProperties.has('endDate')) {
                this.setMappers();
            }
            if (_changedProperties.has('endDate') && this.endDate !== undefined) {
                this.hideContextMenu();
            }
        }
        updated(_changedProperties) {
            if (_changedProperties.has('startDate') || _changedProperties.has('endDate')) {
                this.updateInput();
            }
        }
        async firstUpdated() {
            this.initCmContentContainer();
            await this.updateComplete;
            this.updatePageIndex();
        }
        setMappers() {
            var _a, _b, _c, _d, _e;
            let startYear = (_a = this._preselectedStartYear) !== null && _a !== void 0 ? _a : getYear(this.startDate);
            let endYear;
            if (!isNil(this.endDate) && isNil(this._preselectedStartYear)) {
                // case when endDate is set by user
                endYear = getYear(this.endDate);
            }
            else {
                endYear = this._preselectedEndYear;
            }
            let startMonth = (_b = this._preselectedStartMonth) !== null && _b !== void 0 ? _b : getMonth(this.startDate);
            let endMonth;
            if (!isNil(this.endDate) && isNil(this._preselectedStartMonth)) {
                // case when endDate is set by user
                endMonth = getMonth(this.endDate);
            }
            else {
                endMonth = this._preselectedEndMonth;
            }
            if (!isNil(startYear) && !isNil(endYear) && startYear > endYear) {
                [startYear, endYear] = [endYear, startYear];
            }
            if (!isNil(startMonth) && !isNil(endMonth) && pairLessOrEqual(endMonth, startMonth)) {
                [startMonth, endMonth] = [endMonth, startMonth];
            }
            (_c = this._sdsCalendar) === null || _c === void 0 ? void 0 : _c.setDateStateMapper(dateRangeMapper(this.startDate, this.endDate));
            (_d = this._sdsCalendar) === null || _d === void 0 ? void 0 : _d.setMonthStateMapper(monthRangeMapper(startMonth, endMonth));
            (_e = this._sdsCalendar) === null || _e === void 0 ? void 0 : _e.setYearStateMapper(yearRangeMapper(startYear, endYear));
        }
        resetPage() {
            var _a;
            (_a = this._sdsCalendar) === null || _a === void 0 ? void 0 : _a.navigateTo('SelectDate');
            this.updatePageIndex();
        }
        initCmContentContainer() {
            var _a;
            const sdsCalendar = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('sds-calendar');
            if (sdsCalendar) {
                this._sdsCalendar = sdsCalendar;
            }
        }
        updatePageIndex() {
            var _a, _b;
            if (this.startDate) {
                (_a = this._sdsCalendar) === null || _a === void 0 ? void 0 : _a.setPageIndex(this.startDate[0], this.startDate[1]);
            }
            else if (this.currentDay) {
                const [year, month] = keyToDate(this.currentDay);
                (_b = this._sdsCalendar) === null || _b === void 0 ? void 0 : _b.setPageIndex(year, month);
            }
        }
        hideContextMenu() {
            var _a;
            if ((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened) {
                this._contextMenu.hide();
            }
        }
        updateValue(date) {
            if (date === undefined) {
                this.startDate = undefined;
                this.endDate = undefined;
                this.resetPreselectedValues();
                this.dispatchChange();
            }
            else if (this.startDate === undefined || this.endDate !== undefined) {
                this.startDate = date;
                this.endDate = undefined;
            }
            else {
                this.endDate = date;
                if (tripletLessOrEqual(this.endDate, this.startDate)) {
                    [this.startDate, this.endDate] = [this.endDate, this.startDate];
                }
                this.resetPreselectedValues();
                this.dispatchChange();
            }
        }
        resetPreselectedValues() {
            this._preselectedStartYear = undefined;
            this._preselectedEndYear = undefined;
            this._preselectedStartMonth = undefined;
            this._preselectedEndMonth = undefined;
            this.setMappers();
        }
        updateInput() {
            let inputValue = '';
            if (this.startDate !== undefined) {
                inputValue = displayDate(this.startDate);
            }
            if (this.endDate !== undefined) {
                inputValue += ' - ' + displayDate(this.endDate);
            }
            this._inputDate.value = inputValue;
        }
        dispatchChange() {
            this.dispatchEvent(new CustomEvent(SdsDateRange.DATE_RANGE_CHANGE_EVENT, {
                detail: {
                    startDate: this.startDate ? dateToKey(...this.startDate) : undefined,
                    endDate: this.endDate ? dateToKey(...this.endDate) : undefined,
                },
            }));
        }
    };
    _SdsDateRange_placeholder_accessor_storage = new WeakMap();
    _SdsDateRange_startDate_accessor_storage = new WeakMap();
    _SdsDateRange_endDate_accessor_storage = new WeakMap();
    _SdsDateRange_hint_accessor_storage = new WeakMap();
    _SdsDateRange_disabled_accessor_storage = new WeakMap();
    _SdsDateRange_invalid_accessor_storage = new WeakMap();
    _SdsDateRange_errorMessage_accessor_storage = new WeakMap();
    _SdsDateRange_currentDay_accessor_storage = new WeakMap();
    _SdsDateRange__contextMenu_accessor_storage = new WeakMap();
    _SdsDateRange__inputDate_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsDateRange");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _placeholder_decorators = [property({ type: String })];
        _startDate_decorators = [property({
                type: String,
                converter: keyToDate,
                attribute: 'start-date',
            })];
        _endDate_decorators = [property({
                type: String,
                converter: keyToDate,
                attribute: 'end-date',
            })];
        _hint_decorators = [property({ type: String })];
        _disabled_decorators = [property({ type: Boolean })];
        _invalid_decorators = [property({ type: Boolean })];
        _errorMessage_decorators = [property({ type: String, attribute: 'error-message' })];
        _currentDay_decorators = [property()];
        __contextMenu_decorators = [query('#context-menu')];
        __inputDate_decorators = [query('#input-date')];
        __esDecorate(_classThis, null, _placeholder_decorators, { kind: "accessor", name: "placeholder", static: false, private: false, access: { has: obj => "placeholder" in obj, get: obj => obj.placeholder, set: (obj, value) => { obj.placeholder = value; } }, metadata: _metadata }, _placeholder_initializers, _placeholder_extraInitializers);
        __esDecorate(_classThis, null, _startDate_decorators, { kind: "accessor", name: "startDate", static: false, private: false, access: { has: obj => "startDate" in obj, get: obj => obj.startDate, set: (obj, value) => { obj.startDate = value; } }, metadata: _metadata }, _startDate_initializers, _startDate_extraInitializers);
        __esDecorate(_classThis, null, _endDate_decorators, { kind: "accessor", name: "endDate", static: false, private: false, access: { has: obj => "endDate" in obj, get: obj => obj.endDate, set: (obj, value) => { obj.endDate = value; } }, metadata: _metadata }, _endDate_initializers, _endDate_extraInitializers);
        __esDecorate(_classThis, null, _hint_decorators, { kind: "accessor", name: "hint", static: false, private: false, access: { has: obj => "hint" in obj, get: obj => obj.hint, set: (obj, value) => { obj.hint = value; } }, metadata: _metadata }, _hint_initializers, _hint_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _invalid_decorators, { kind: "accessor", name: "invalid", static: false, private: false, access: { has: obj => "invalid" in obj, get: obj => obj.invalid, set: (obj, value) => { obj.invalid = value; } }, metadata: _metadata }, _invalid_initializers, _invalid_extraInitializers);
        __esDecorate(_classThis, null, _errorMessage_decorators, { kind: "accessor", name: "errorMessage", static: false, private: false, access: { has: obj => "errorMessage" in obj, get: obj => obj.errorMessage, set: (obj, value) => { obj.errorMessage = value; } }, metadata: _metadata }, _errorMessage_initializers, _errorMessage_extraInitializers);
        __esDecorate(_classThis, null, _currentDay_decorators, { kind: "accessor", name: "currentDay", static: false, private: false, access: { has: obj => "currentDay" in obj, get: obj => obj.currentDay, set: (obj, value) => { obj.currentDay = value; } }, metadata: _metadata }, _currentDay_initializers, _currentDay_extraInitializers);
        __esDecorate(_classThis, null, __contextMenu_decorators, { kind: "accessor", name: "_contextMenu", static: false, private: false, access: { has: obj => "_contextMenu" in obj, get: obj => obj._contextMenu, set: (obj, value) => { obj._contextMenu = value; } }, metadata: _metadata }, __contextMenu_initializers, __contextMenu_extraInitializers);
        __esDecorate(_classThis, null, __inputDate_decorators, { kind: "accessor", name: "_inputDate", static: false, private: false, access: { has: obj => "_inputDate" in obj, get: obj => obj._inputDate, set: (obj, value) => { obj._inputDate = value; } }, metadata: _metadata }, __inputDate_initializers, __inputDate_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsDateRange = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.DATE_RANGE_CHANGE_EVENT = 'sds.date-range.changed';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsDateRange = _classThis;
})();
export { SdsDateRange };
